isTrello = require 'app/scripts/lib/util/url/is-trello'

module.exports = (url) ->
  switch
    when isTrello(url) then 'trello'
    when /// docs\.google\.com/ ///i.test(url) ||
      /// drive\.google\.com/ ///i.test(url) then 'google-drive'
    when /// dropbox\.com/ ///i.test(url) then 'dropbox'
    when /// onedrive\.live\.com/ ///i.test(url) ||
      /// 1drv\.ms/ ///i.test(url)  ||
      /// sharepoint\.com/ ///i.test(url) then 'onedrive'
    when /// app\.box\.com/ ///i.test(url) then 'box'
    else 'link'
